/**
 * @flow
 */

import React from 'react';
import gql from 'graphql-tag';
import { useQuery } from '@apollo/client';
import { useSelector } from 'react-redux';
import { map, uniqBy, property } from 'lodash';
import Fuse from 'fuse.js';

import { Select } from '../../../../../components';

const GET_ADMINISTRATORS_QUERY = gql`
    query getAdministrators($salon: ID!) {
        viewer {
            id
            ... on Administrator {
                salon(id: $salon) {
                    id
                    administrator {
                        id
                        ...administrator
                    }
                    administrators {
                        id
                        ...administrator
                    }
                    masters {
                        nodes {
                            id
                            firstName
                            lastName
                        }
                    }
                }
            }
        }
    }

    fragment administrator on Administrator {
        firstName
        lastName
    }
`;

export { GET_ADMINISTRATORS_QUERY };

const mapOptions = ({ id, firstName, lastName }) => ({
    text: `${firstName} ${lastName}`,
    value: id,
});

function AdministratorSelect({ value, onChange, ...rest }) {
    const salon = useSelector(({ user }) => user.get('salon'));

    const { data, loading } = useQuery(GET_ADMINISTRATORS_QUERY, {
        variables: { salon },
        skip: !salon,
    });

    const sellers =
        !loading && data && data.viewer
            ? uniqBy(
                  [
                      data.viewer.salon.administrator,
                      ...data.viewer.salon.administrators,
                      ...data.viewer.salon.masters.nodes,
                  ],
                  property('id'),
              )
            : [];

    const options = map(sellers, mapOptions);

    const search = (items, searchValue) => {
        const fuse = new Fuse(sellers, {
            keys: ['lastName', 'firstName'],
            shouldSort: true,
            threshold: 0.3,
        });
        return map(fuse.search(searchValue), mapOptions);
    };

    return (
        <Select
            value={value}
            onChange={onChange}
            options={options}
            search={search}
            loading={loading}
            {...rest}
        />
    );
}

export default AdministratorSelect;
